export const ListGoalMetricTypes = Object.freeze({
  QUANTITY: 0,
  AMOUNT: 1,
  PERCENTAGE: 2
})
export const ListGoalTypes = Object.freeze({
  INCREMENTAL: 0,
  PRODUÇÃO: 1
})
export const ListGoalPeriods = Object.freeze({
  MENSAL: 0,
  BIMESTRAL: 1,
  TRIMESTRAL: 2
})



// WEBPACK FOOTER //
// ./src/enums/enumGoalMetricTypes.js